import toastr from 'toastr';

export default function (error, router, errorMessage) {
  const {status} = error.response || {};
  if (status === 400) return;
  if (status === 403) {
    router.push('/not-authorized');
    return;
  }
  if (status === 401) {
    router.push('/log-in');
    return;
  }
  toastr.error(errorMessage, 'Error');
  if (!status) throw error;
}



// WEBPACK FOOTER //
// ./app/features/shared/services/handleApiError.js